import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from "redux"
import Cards from 'react-credit-cards'
import './style.css'
import 'react-credit-cards/es/styles-compiled.css'
import createConnectedInput from "../../../../../../redux/actions-reducers/form/create-connected-input"
import {FORM_CARD_INFO_NAME} from "./reducer"
import NRTTextInput from "../../../../../../components/_common/_controlled-inputs/TextInput"
import NRTHorizontalStack from "../../../../../../components/_common/_containers/HorizontalStack"
import NRTVerticalStack from "../../../../../../components/_common/_containers/VerticalStack"
import createFormActions from "../../../../../../redux/actions-reducers/form/create-form-actions"

const createInput = createConnectedInput(FORM_CARD_INFO_NAME)
const CardNumberInput = createInput('number', NRTTextInput)
const CardHolderNameInput = createInput('holderName', NRTTextInput)
const CardValidThruInput = createInput('validThru', NRTTextInput)
const CardCVCInput = createInput('cvc', NRTTextInput)

export class FormCardInfo extends Component {

    state = {
        showingCardBack: false,
    }

    componentDidMount(){
        this.props.reset()
    }

    componentWillUnmount(){
        this.props.reset()
    }

    turnCard = (showBack = false) => {
        this.setState({showingCardBack: showBack})
    }


    render() {
        const {form} = this.props
        const {showingCardBack} = this.state
        const num = /[0-9]/

        return (
            <div className='nrt-form-card-info'>

                <NRTVerticalStack>
                    <Cards
                        number={form.values.number || ''}
                        name={form.values.holderName || ''}
                        expiry={form.values.validThru || ''}
                        cvc={form.values.cvc || ''}
                        focused={showingCardBack ? 'cvc' : ''}

                    />

                    <form>
                        <NRTVerticalStack>
                            <CardNumberInput
                                label='Número'
                                x-autocompletetype="cc-number"
                                mask={[
                                    num, num, num, num, ' ',
                                    num, num, num, num, ' ',
                                    num, num, num, num, ' ',
                                    num, num, num, num,
                                ]}
                            />

                            <CardHolderNameInput label='Nome'/>
                            <NRTHorizontalStack>
                                <CardValidThruInput label='Valido até'
                                                    mask={[num, num, '/', num, num]}
                                />
                                <CardCVCInput label='Cod. segurança'
                                              onFocus={() => this.turnCard(true)}
                                              onBlur={() => this.turnCard(false)}

                                              mask={[num, num, num]}

                                />
                            </NRTHorizontalStack>
                        </NRTVerticalStack>
                    </form>

                </NRTVerticalStack>


            </div>
        )
    }
}


FormCardInfo.propTypes = {}

FormCardInfo.defaultProps = {}


const mapStateToProps = (state) => {
    return {
        form: state[FORM_CARD_INFO_NAME]
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({

    reset: createFormActions(FORM_CARD_INFO_NAME).reset
}, dispatch)

const connectedCmp = connect(mapStateToProps, mapDispatchToProps)(FormCardInfo)
const testCmp =  () => null

const exportedCmp = process.env.NODE_ENV === 'test' ? testCmp: connectedCmp

export default exportedCmp



// WEBPACK FOOTER //
// ./src/_pages/Sale/_partials/PaymentStep/_components/FormCardInfo/index.js